<header class="w-full relative bg-OUT-Cream px-3 md:px-5 2xl:px-28 3xl:px-52 py-2.5 lg:py-4">
  <section
    class="container mx-auto flex items-center justify-between gap-12 2xl:gap-22"
  >
    <div>
      <a routerLink="/">
        <out-image
          alt="Only Used Tesla logo"
          [src]="logoSrc"
          [class]="'max-w-[190px] lg:max-w-[240px]'"
        ></out-image>
      </a>
    </div>

    <div class="w-full gap-4 hidden lg:flex justify-between items-center">
      <nav class="gap-3 xl:gap-6 font-medium hidden lg:flex">
        <ng-container *ngFor="let item of menuItems">
          <!-- Check if the item does not require auth or if the user is authenticated -->
          <ng-container
            *ngIf="
              item.auth === undefined ||
              (item.auth && (auth.isAuthenticated$ | async)) ||
              (!item.auth && (auth.isAuthenticated$ | async) === false)
            "
          >
            <!-- For normal navigation items -->
            <a
              *ngIf="!item.external && !item.click && !item.isRegister"
              [routerLink]="item.url"
              [queryParams]="item.initialQueryParams || {}"
              class="link relative hover:text-[#E54546] transition-colors duration-300"
              routerLinkActive="active"
              [ngClass]="{ current: currentLink?.startsWith(item.url) }"
            >
              {{ item.label }}
            </a>

            <!-- For external links -->
            <a
              *ngIf="item.external && !item.click"
              [href]="item.url"
              class="link"
              [ngClass]="{ current: currentLink === item.url }"
            >
              {{ item.label }}
            </a>
          </ng-container>
        </ng-container>
      </nav>
      <div
        *ngIf="
          this.environmentService.authentication &&
          (auth.isAuthenticated$ | async)
        "
        class="flex items-center gap-3"
      >
        <div
          *ngIf="user$ | async as user"
          class="relative hidden lg:flex items-center"
          outClickOutside
          (outClickOutside)="showDropdown = false"
        >
          <!-- Button to toggle dropdown -->
          <button
            (click)="toggleDropdown()"
            class="flex items-center gap-2 px-3 rounded-full cursor-pointer"
          >
            <img
              class="rounded-full size-9"
              [src]="
                'https://ui-avatars.com/api/?background=1466c9&color=fff&name=' +
                user['https://onlyusedtesla.com/firstName']
              "
              alt="user avatar"
            />
            <p class="text-sm uppercase font-medium hidden 2xl:block">
              {{ user['https://onlyusedtesla.com/firstName'] }}
            </p>
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          <!-- Dropdown content -->
          <div
            *ngIf="showDropdown"
            class="absolute right-0 top-12 w-48 bg-white shadow border !border-OUT-Cream/30 shadow-lg rounded-md z-50 overflow-hidden"
          >
            <div class="flex flex-col gap-2 p-1.5">
              <a
                (click)="toggleDropdown()"
                routerLink="/account"
                class="flex items-center gap-1 text-left px-4 py-2 text-sm hover:bg-gray-200 rounded transition-colors duration-300"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                >
                  <g fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="12" cy="6" r="4" />
                    <path
                      d="M20 17.5c0 2.485 0 4.5-8 4.5s-8-2.015-8-4.5S7.582 13 12 13s8 2.015 8 4.5Z"
                    />
                  </g>
                </svg>
                My Dashboard
              </a>
              <button
                (click)="logout()"
                class="flex items-center gap-1 w-full text-left px-4 py-2 text-sm hover:bg-gray-200 rounded transition-colors duration-300 cursor-pointer text-OUT-Red"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M14.945 1.25c-1.367 0-2.47 0-3.337.117c-.9.12-1.658.38-2.26.981c-.524.525-.79 1.17-.929 1.928c-.135.737-.161 1.638-.167 2.72a.75.75 0 0 0 1.5.008c.006-1.093.034-1.868.142-2.457c.105-.566.272-.895.515-1.138c.277-.277.666-.457 1.4-.556c.755-.101 1.756-.103 3.191-.103h1c1.436 0 2.437.002 3.192.103c.734.099 1.122.28 1.4.556c.276.277.456.665.555 1.4c.102.754.103 1.756.103 3.191v8c0 1.435-.001 2.436-.103 3.192c-.099.734-.279 1.122-.556 1.399s-.665.457-1.399.556c-.755.101-1.756.103-3.192.103h-1c-1.435 0-2.436-.002-3.192-.103c-.733-.099-1.122-.28-1.399-.556c-.243-.244-.41-.572-.515-1.138c-.108-.589-.136-1.364-.142-2.457a.75.75 0 1 0-1.5.008c.006 1.082.032 1.983.167 2.72c.14.758.405 1.403.93 1.928c.601.602 1.36.86 2.26.982c.866.116 1.969.116 3.336.116h1.11c1.368 0 2.47 0 3.337-.116c.9-.122 1.658-.38 2.26-.982s.86-1.36.982-2.26c.116-.867.116-1.97.116-3.337v-8.11c0-1.367 0-2.47-.116-3.337c-.121-.9-.38-1.658-.982-2.26s-1.36-.86-2.26-.981c-.867-.117-1.97-.117-3.337-.117z"
                  />
                  <path
                    fill="currentColor"
                    d="M15 11.25a.75.75 0 0 1 0 1.5H4.027l1.961 1.68a.75.75 0 1 1-.976 1.14l-3.5-3a.75.75 0 0 1 0-1.14l3.5-3a.75.75 0 1 1 .976 1.14l-1.96 1.68z"
                  />
                </svg>
                Log Out
              </button>
            </div>
          </div>
        </div>

        <!-- <div *ngIf="user$ | async as user" class="hidden xl:flex items-center">
          <img
            class="rounded-full size-9"
            [src]="
              'https://ui-avatars.com/api/?background=1466c9&color=fff&name=+' +
              user['https://onlyusedtesla.com/firstName']
            "
            alt="user avatar"
          />
          <p
            class="text-sm uppercase text-lg px-2 py-1.5 rounded-full font-medium"
            *ngIf="user$ | async as user"
          >
            {{ user['https://onlyusedtesla.com/firstName'] }}
          </p>
        </div>
        <div class=""></div>
        <button
          (click)="logout()"
          class="bg-OUT-Blue text-white px-6 py-1.5 cursor-pointer rounded-full font-semibold hover:bg-OUT-Blue/80 transition-colors duration-400"
        >
          Log Out
        </button> -->
      </div>
      <div
        *ngIf="
          (auth.isAuthenticated$ | async) === false &&
          this.environmentService.authentication
        "
        class="flex gap-4 items-center"
      >
        <a
          tabindex="0"
          role="button"
          (click)="login()"
          (keydown.enter)="login()"
          class="text-OUT-Blue font-semibold cursor-pointer"
          >Log In
        </a>
        <a
          tabindex="0"
          role="button"
          (click)="login()"
          (keydown.enter)="login()"
          class="bg-OUT-Blue text-white cursor-pointer px-7 py-1.5 rounded-full font-semibold hover:bg-OUT-Blue/80 transition-colors duration-400"
          >Register
        </a>
      </div>
    </div>

    <div class="lg:hidden">
      <button
        (click)="toggleSidebar()"
        class="hover:bg-[#B6ACA4] p-0.5 cursor-pointer transition-all duration-300 rounded-md"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M4 17.27v-1h16v1zm0-4.77v-1h16v1zm0-4.77v-1h16v1z"
          />
        </svg>
      </button>
    </div>
  </section>
</header>

<!-- Sidebar -->
<aside class="lg:hidden relative">
  <section
    class="h-screen w-full bg-OUT-Cream fixed top-0 left-0 overflow-hidden duration-300 transition-all z-[500]"
    [ngClass]="isSidebarVisible ? 'translate-x-0' : '-translate-x-full'"
  >
    <div class="w-full flex justify-between items-center mt-2 px-3">
      <!-- Logo -->
      <a routerLink="/" (click)="toggleSidebar()">
        <img class="size-10" [src]="sideLogoSrc" alt="Only Used Tesla Logo" />
      </a>

      <!-- Close Button -->
      <button
        class="hover:bg-[#B6ACA4] transition-all duration-300 rounded-md cursor-pointer"
        (click)="toggleSidebar()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.5"
            d="m7.757 16.243l8.486-8.486m0 8.486L7.757 7.757"
          />
        </svg>
      </button>
    </div>

    <nav class="flex flex-col gap-2 text-2xl font-semibold mt-10 px-3">
      <ng-container *ngFor="let item of navLinks">
        <!-- Check if the item does not require auth or if the user is authenticated -->
        <ng-container
          *ngIf="
            item.auth === undefined ||
            (item.auth && (auth.isAuthenticated$ | async)) ||
            (!item.auth && (auth.isAuthenticated$ | async) === false)
          "
        >
          <!-- Check if the item is not an external link -->
          <a
            *ngIf="
              !item.external && !item.click && !item.isRegister && !item.head
            "
            [routerLink]="item.url"
            routerLinkActive="active"
            (click)="toggleSidebar()"
            class="hover:text-OUT-Red transition-colors duration-400"
          >
            {{ item.label }}
          </a>

          <!-- Check if the item is an external link -->
          <a
            *ngIf="
              item.external && !item.click && !item.isRegister && !item.head
            "
            [href]="item.url"
            routerLinkActive="active"
            (click)="toggleSidebar()"
            class="hover:text-OUT-Red transition-colors duration-400"
          >
            {{ item.label }}
          </a>

          <!-- Check if the item is a register link -->
          <a
            *ngIf="
              item.isLogout &&
              item.click &&
              this.environmentService.authentication
            "
            href="#"
            (click)="item.click()"
            routerLinkActive="active"
            class="text-OUT-Red cursor-pointer hover:text-OUT-Red transition-colors duration-400"
            (click)="toggleSidebar()"
          >
            {{ item.label }}
          </a>
        </ng-container>
      </ng-container>

      <div
        *ngIf="
          (auth.isAuthenticated$ | async) === false &&
          this.environmentService.authentication
        "
        class="flex flex-col gap-2"
      >
        <a
          tabindex="0"
          role="button"
          (click)="login()"
          (keydown.enter)="login()"
          class="font-semibold cursor-pointer hover:text-OUT-Red transition-colors duration-400"
          >Log In
        </a>
        <a
          tabindex="0"
          role="button"
          (click)="login()"
          (keydown.enter)="login()"
          class="cursor-pointer font-semibold text-OUT-Red hover:text-red-900 transition-colors duration-400"
          >Register
        </a>
      </div>
    </nav>
  </section>
</aside>
